import { OutlinedTextFieldProps, TextField, Tooltip } from "@mui/material";
import { isNil, isUndefined } from "lodash";

export interface BaseTextFieldBaseProps extends Omit<OutlinedTextFieldProps, "fullWidth" | "autoComplete" | "size" | "variant"> {
    tooltip?: string
}

const BaseTextField = (props: BaseTextFieldBaseProps) => {

    let { tooltip, value, required, label, ...fwdProps } = props

    if (isUndefined(tooltip))
        tooltip = "";

    if (isNil(value))
        value = "";

    if (!isUndefined(required) && required)
        label = label + " *";

    return (
        <Tooltip title={tooltip}>
            <TextField

                {...fwdProps}

                size="small"

                fullWidth

                value={value}

                label={label}

            />
        </Tooltip>
    )
}

export default BaseTextField;